function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, formErrors, formValues) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['auth-banners'] = function({
      success,
      info,
      error
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((success) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `success-banner`,
                theme: `success`,
                size: `small`,
                type: `embedded`,
                'body-text': success,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((info) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `info-banner`,
                theme: `info`,
                size: `medium`,
                type: `embedded`,
                'body-text': info,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((error) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `error-banner`,
                theme: `warn`,
                size: `medium`,
                type: `embedded`,
                'body-text': error,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['invisible-enter'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": __vjadeStringifyAttrsIfObj({
              type: `submit`,
              tabindex: -1 /* disable tab focus */
            }
            /* awful hack because some browsers disable Enter key submission when display: none */
          ),
          "style": {
            'position': `absolute`,
            'left': `-9999px`,
            'width': `1px`,
            'height': `1px`
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['submit-button'] = function(message) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": __vjadeStringifyAttrsIfObj({
            theme: `primary`,
          }),
          "on": {
            click: $helpers.handleSubmitClick,
          },
        }, [__vjadeSafeCode(message)]));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['back-button'] = function(message) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": __vjadeStringifyAttrsIfObj({
            theme: `secondary`
          }),
          "on": {
            click: this.helpers.handleClickBackButton
          },
          "class": {
            'back-btn': true
          },
        }, [__vjadeSafeCode(message)]));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['hidden-csrf'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            type: `hidden`,
            name: `csrfmiddlewaretoken`,
            value: $helpers.getCsrfToken()
          }),
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['hidden-twofactor-selection'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            type: `hidden`,
            name: `twofactor_selection`,
            value: `sms`
          }),
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['sms-setup-form'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("form", {
          "attrs": __vjadeStringifyAttrsIfObj({
            action: `/security/twofactor/setup/sms/`,
            method: `post`,
          }),
          "hook": {
            insert: $helpers.onFormInserted,
          },
          "on": {
            submit: $helpers.handleSubmit,
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("h1", {
            "class": {
              'auth-form-title': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Set Up Your Two-Factor Authentication");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-input-label", {
            "attrs": __vjadeStringifyAttrsIfObj({
              label: `Your Phone Number`
            }),
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'flex-form-field': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'country-code': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'field-name': `country_code`,
                  'validation-status': formErrors.countryCode ? `invalid` : ``,
                  'error-message': formErrors.countryCode,
                  placeholder: `+1`,
                }),
                "props": {
                  value: formValues.countryCode,
                },
                "on": {
                  input: (ev) => $helpers.handleInput($helpers.FormField.CountryCode, ev),
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'phone-number': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'field-name': `phone`,
                  'validation-status': formErrors.phoneNumber ? `invalid` : ``,
                  'error-message': formErrors.phoneNumber,
                  placeholder: `(415) 123-1322`
                }),
                "on": {
                  input: (ev) => $helpers.handleInput($helpers.FormField.PhoneNumber, ev),
                  blur: $helpers.handleBlur,
                },
                "hook": {
                  insert: ({
                    elm
                  }) => elm.focus()
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['submit-button'].call(this, `Continue`));
            __jade_nodes = __jade_nodes.concat(jade_mixins['back-button'].call(this, `Back`));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['hidden-csrf'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['hidden-twofactor-selection'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['invisible-enter'].call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['verify-form'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("form", {
          "attrs": __vjadeStringifyAttrsIfObj({
            action: `/security/twofactor/verify/sms/`,
            method: `post`,
          }),
          "hook": {
            insert: $helpers.onFormInserted,
          },
          "on": {
            submit: $helpers.handleSubmit,
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("h1", {
            "class": {
              'auth-form-title': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Two-factor verification");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'field-id': `code`,
                'field-name': `code`,
                'validation-status': formErrors.verificationCode ? `invalid` : ``,
                'error-message': formErrors.verificationCode,
                label: `Verification code`,
              }),
              "on": {
                input: (ev) => $helpers.handleInput($helpers.FormField.VerificationCode, ev),
                blur: $helpers.handleBlur,
              },
              "hook": {
                insert: ({
                  elm
                }) => elm.focus()
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['submit-button'].call(this, `Log in`));
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": __vjadeStringifyAttrsIfObj({
              href: `/security/twofactor/setup`,
            }),
            "class": {
              'auth-link': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Back");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['hidden-csrf'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['hidden-twofactor-selection'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['invisible-enter'].call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("auth-container", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'show-footer-links': true,
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            slot: `auth-form-slot`
          }),
          "class": {
            'auth-form': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['auth-banners'].call(this, {
            error: $helpers.getErrors(),
            info: $helpers.getInfo()
          }));
          __jade_nodes = __jade_nodes.concat(($attr(`step`) === $helpers.TwoFactorStep.Setup) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['sms-setup-form'].call(this));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['verify-form'].call(this));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "formErrors" in locals ? locals.formErrors : typeof formErrors !== "undefined" ? formErrors : undefined, "formValues" in locals ? locals.formValues : typeof formValues !== "undefined" ? formValues : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;